module.exports = __webpack_public_path__ + "img/cargo_dg_woodpacking_example.c16dca17.svg";